<template>
  <li class="mobile-offers" data-test="mobile-menu__offers">
    <ul>
      <MobileMenuItem
        :item="config.item"
        :panel="true"
        :utag-event-info="{
          event_act: 'view all deals',
          event_cat: 'offers',
          event_lbl: 'dropdown',
        }"
      >
        <template #panel>
          <h5 class="title-subpanel t-fb-label">{{ config.a11y.hotels_offers }}</h5>
          <div class="inner offer-items-container">
            <!-- AQUÍ VAN LAS OFERTAS DESDE EL TEMPLATE -->
          </div>
          <h5 class="title-subpanel t-fb-label">{{ config.a11y.general_offers }}</h5>
          <div class="banners-container">
            <!-- AQUÍ VAN LOS BANNERS DESDE EL TEMPLATE -->
          </div>
          <div class="menu-item view-all offer-banner--container child-item">
            <a :href="config.a11y.all_url" class="view-all fake-link utag-special-offers-all-menu">
              {{ config.a11y.all }}
            </a>
          </div>
        </template>
      </MobileMenuItem>
    </ul>
  </li>
</template>
<script>
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem'

const componentName = 'MobileMenuOffers'

export default {
  name: componentName,
  components: {
    MobileMenuItem,
  },
  props: {
    config: Object,
  },
}
</script>
